var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{attrs:{"appear":""},on:{"enter":_vm.enter}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }